var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54414 2.00288C2.72691 1.9849 2.90783 2.05171 3.03502 2.18415L8.00429 7.14971L12.9719 2.18415C13.0586 2.09496 13.1704 2.03552 13.2912 2.01287L13.3832 2.00288C13.6295 1.99563 13.8552 2.13992 13.9519 2.36652C14.0486 2.59312 13.9967 2.85582 13.821 3.02861L8.85114 7.99657L13.821 12.9631C13.9511 13.093 14.0133 13.274 13.9935 13.4536L13.9767 13.543C13.9212 13.7502 13.7593 13.9121 13.552 13.9676C13.3447 14.023 13.1236 13.9637 12.9719 13.812L8.00429 8.84343L3.03502 13.812C2.90646 13.9483 2.72301 14.0153 2.53996 13.9971L2.44873 13.9808C2.23712 13.9259 2.07221 13.7602 2.01843 13.5484C1.96465 13.3365 2.03054 13.1122 2.19036 12.9631L7.15743 7.99657L2.19036 3.02861C2.04427 2.88703 1.98143 2.68269 2.01878 2.48659L2.04097 2.40326C2.11677 2.18349 2.31292 2.02742 2.54414 2.00288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.173b6c8a278029838a67158435dbaef2.svg";
export { ForwardRef as ReactComponent };